import {
  QuestionIcon,
  MessageIcon,
  SuitcaseIcon,
  CoinIcon,
  BookIcon,
  EmergencyIcon,
} from "components/Icons";

const iconStyle = "fill-current text-teal-500";

const menus = [
  {
    id: "account_statement",
    name: "Cashiering",
    icon: <CoinIcon className={iconStyle} />,
  },
  {
    id: "logbook",
    name: "Log Book",
    icon: <BookIcon className={iconStyle} />,
  },
  {
    id: "incidents",
    name: "Incidents",
    icon: <EmergencyIcon className={iconStyle} />,
    data: 4,
  },
  {
    id: "messaging",
    name: "Messaging",
    icon: <MessageIcon className={iconStyle} />,
  },
  {
    id: "bellboy",
    name: "Bellboy",
    icon: <SuitcaseIcon className={iconStyle} />,
  },
  {
    id: "help",
    name: "Help",
    icon: <QuestionIcon className={iconStyle} />,
  },
];

function onClick(menu) {
  console.log("Menu item clicked...", menu.id);
}

const styleHead = "text-2xl text-center mt-8 mb-4 mx-auto text-neutral-700";

function DeskMenu({ disabled }) {
  if (disabled) {
    return (
      <div className={styleHead}>
        Panel de <span className="font-bold">Asistentes</span>
      </div>
    );
  }

  return (
    <div>
      <h2 className={styleHead}>
        Panel de <span className="font-bold">Asistentes</span>
      </h2>
      <div className="mt-2">
        {menus.map((menu) => (
          <button
            type="button"
            key={menu.name}
            className="flex px-4 rounded-md py-4 hover:bg-stone-100 cursor-pointer"
            onClick={() => onClick(menu)}
          >
            {menu.icon}
            <span className="ml-3">{menu.name}</span>
            {menu.data && (
              <div className="flex ml-2 bg-sky-200 w-6 h-6 font-bold text-center rounded-full text-xs">
                <span className="my-auto mx-auto text-sky-800">
                  {menu.data}
                </span>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

export default DeskMenu;
